import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _AcademicEducation, _WorkExperienceAccount } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { SelectTHConstantsValue } from "../../../../bpm/config/Componentes/SelectTHConstantsValue";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { DepartamentCitiesEditor } from "../../../../../portal/componets/pages/IndexPage/Components/PersonarDataUser/Components/DepartamentCitiesEditor";
import { SelectSiteID } from "../../../../admin/configuracion/SiteID/SelectSiteID";
import usePaginator from "../../../../theme/Component/usePaginator";


interface Props {
    Account: number;
}

export const WorkExperienceAccount = ({ Account }: Props) => {

    const WorkExperienceAccount = useDataBean(_WorkExperienceAccount);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();
    useEffect(() => {
        getListavdos();
    }, [Account])

    const getLista = () => {

        WorkExperienceAccount.instance.getWorkExperienceAccountCatalogPorPropiedades({ State: 1, IDAccount: Account }, null).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    console.log(resp)
                }
            }
        )

    }

    const getListavdos = () => {

        WorkExperienceAccount.instance.getWorkExperienceAccountReport(paginador.page, 15, { State: 1, IDAccount: Account }).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }
            }
        )

    }

    const create = () => {
        WorkExperienceAccount.setBean({
            IDAccount: Account,
            State: 1,
            IDEmployee: _single.getAccountID(),
        });
        setModal({ ...modal, "view": true });
    }

    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        WorkExperienceAccount.update().then(
            (resp: any) => {
                getListavdos();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const deleteItem = () => {
        WorkExperienceAccount.bean.State = 2;
        //console.log(Project.bean);
        editaItem();
        setModalC({ ...modalC, "view": false });

    }
    const head = [
        { title: 'ID', property: 'IDWorkExperienceAccount', visible: true },
        { title: 'Nombre de la empresa', property: 'Organization', visible: true },
        { title: 'Cargo', property: 'Position', visible: true },
        { title: 'Principales funciones', property: 'MainFunctions', visible: true },
        { title: 'Fecha Inicial', property: 'StartDate', visible: true },
        { title: 'Fecha Final', property: 'EndDate', visible: true },
        { title: 'Tipo Contrato', property: 'IDContractTypeName', visible: true },
        { title: 'Tipo sector', property: 'IDSector', visible: true },
        { title: 'Ciudad', property: 'City', visible: true },
        { title: 'Departamento', property: 'NameDepartament', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={WorkExperienceAccount.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador}></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Nombre de la empresa</label>
                            <input type='text' name="Organization" className="form-control" value={WorkExperienceAccount.bean.Organization} onChange={WorkExperienceAccount.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <label>Cargo</label>
                            <input type='text' name="Position" className="form-control" value={WorkExperienceAccount.bean.Position} onChange={WorkExperienceAccount.handleChange} />
                        </div>
                        <div className="col-md-6">
                            <InputDate name="StartDate" label="Fecha Inicial" value={WorkExperienceAccount.bean.StartDate} setDate={(e: any) => { WorkExperienceAccount.setBean({ ...WorkExperienceAccount.bean, "StartDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <InputDate name="EndDate" label="Fecha Final" value={WorkExperienceAccount.bean.EndDate} setDate={(e: any) => { WorkExperienceAccount.setBean({ ...WorkExperienceAccount.bean, "EndDate": e }) }} />
                        </div>
                        <div className="col-md-6">
                            <label>Tipo Contrato</label>
                            <SelectTHConstantsValue code={804} value={WorkExperienceAccount.bean.IDContractType} onChange={(e: any) => { WorkExperienceAccount.setBean({ ...WorkExperienceAccount.bean, "IDContractType": e }) }}></SelectTHConstantsValue>
                        </div>
                        <div className="col-md-6">
                            <label>Tipo sector</label>
                            <SelectTHConstantsValue code={805} value={WorkExperienceAccount.bean.IDSector} onChange={(e: any) => { WorkExperienceAccount.setBean({ ...WorkExperienceAccount.bean, "IDSector": e }) }}></SelectTHConstantsValue>
                        </div>
                        <div className="col-md-6">
                            <SelectSiteID label="Ciudad" edit idLnSite={WorkExperienceAccount.bean.City} onChange={(e) => { WorkExperienceAccount.setBean({ ...WorkExperienceAccount.bean, "City": e.IDLn }) }} />
                        </div>
                        <div className="col-md-6">

                            <DepartamentCitiesEditor
                                idSelector={WorkExperienceAccount.bean.Department}
                                onChange={(e) => WorkExperienceAccount.setBean({ ...WorkExperienceAccount.bean, 'Department': e.IDCities, 'renderValue': e.Ciudad ?? e.Name })}

                            />
                        </div>
                        <div className="col-md-12">
                            <label>Principales funciones</label>
                            <textarea name="MainFunctions" className="form-control" value={WorkExperienceAccount.bean.MainFunctions} onChange={WorkExperienceAccount.handleChange} />
                        </div>
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}